import { request } from './request'

const USE_MOCK = process.env.VUE_APP_USE_MOCK !== 'false'

export const NOTIFICATION_FILTER_OPTIONS = [
  { value: 'all', label: 'notifications.filter.all' },
  { value: 'promotion', label: 'notifications.filter.unread' },
  { value: 'member', label: 'notifications.filter.member' },
  { value: 'order', label: 'notifications.filter.order' },
  { value: 'logistics', label: 'notifications.filter.logistics' }
]

const MOCK_NOTIFICATIONS = [
  {
    id: 1,
    title: '訂單已發貨',
    content: '您的訂單 #TC2026060401 已發貨，預計 3-5 個工作天送達。',
    createdAt: '2026-06-04T14:30:00',
    category: 'logistics'
  },
  {
    id: 2,
    title: '新客專享優惠',
    content: '歡迎加入 TIME Club！首次訂單可享 95 折優惠，優惠碼：WELCOME95。',
    createdAt: '2026-06-03T09:00:00',
    category: 'promotion'
  },
  {
    id: 3,
    title: '積分入帳通知',
    content: '您於 6 月 2 日的消費已獲得 128 TIME Club 積分，可於會員中心查看。',
    createdAt: '2026-06-02T18:20:00',
    category: 'member'
  },
  {
    id: 4,
    title: '限時推廣提醒',
    content: '世界名茄風味巡禮活動進行中，精選品牌限時 7 折起，把握優惠時機。',
    createdAt: '2026-06-01T11:15:00',
    category: 'promotion'
  },
  {
    id: 5,
    title: '訂單已確認',
    content: '您的訂單 #TC2026052808 已確認，我們正在為您準備商品。',
    createdAt: '2026-05-28T16:45:00',
    category: 'order'
  }
]

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

function formatNotificationTime(isoString) {
  const date = new Date(isoString)
  const now = new Date()
  const diffMs = now - date
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))

  if (diffDays === 0) {
    return `今天 ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
  }
  if (diffDays === 1) {
    return '昨天'
  }
  if (diffDays < 7) {
    return `${diffDays} 天前`
  }

  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

function normalizeNotification(item, readIds = []) {
  return {
    id: item.id,
    title: item.title,
    content: item.content,
    category: item.category || 'all',
    time: item.time || formatNotificationTime(item.createdAt),
    read: item.read != null ? item.read : readIds.includes(item.id)
  }
}

export function getReadStorageKey(userEmail) {
  return `notifications_read_${userEmail || 'guest'}`
}

export function loadReadIds(userEmail) {
  try {
    const raw = localStorage.getItem(getReadStorageKey(userEmail))
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function saveReadIds(userEmail, ids) {
  localStorage.setItem(getReadStorageKey(userEmail), JSON.stringify(ids))
}

/**
 * 獲取用戶通知列表
 * 後端就緒後將 VUE_APP_USE_MOCK 設為 false，並配置 VUE_APP_API_BASE_URL
 */
export async function fetchNotifications(userEmail) {
  const readIds = loadReadIds(userEmail)

  if (USE_MOCK) {
    await delay(400)
    return MOCK_NOTIFICATIONS.map(item => normalizeNotification(item, readIds))
  }

  const data = await request('/api/notifications', {
    headers: userEmail ? { 'X-User-Email': userEmail } : {}
  })

  const list = Array.isArray(data) ? data : (data.list || [])
  return list.map(item => normalizeNotification(item, readIds))
}

/**
 * 標記單條通知已讀（mock 模式寫入 localStorage）
 */
export async function markNotificationAsRead(userEmail, notificationId) {
  if (USE_MOCK) {
    const readIds = loadReadIds(userEmail)
    if (!readIds.includes(notificationId)) {
      saveReadIds(userEmail, [...readIds, notificationId])
    }
    return { success: true }
  }

  return request(`/api/notifications/${notificationId}/read`, { method: 'POST' })
}

/**
 * 標記全部通知已讀
 */
export async function markAllNotificationsAsRead(userEmail, notificationIds) {
  if (USE_MOCK) {
    saveReadIds(userEmail, notificationIds)
    return { success: true }
  }

  return request('/api/notifications/read-all', { method: 'POST' })
}
